import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentenceCase'
})
export class SentenceCasePipe implements PipeTransform {
  private defaultKeywords: string[] = [
    'US','SSN','Canadian','mySedgwick','Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'
  ];

  transform(value: string, customKeywords?: string[]): string {
    if (!value || typeof value !== 'string') return value;
    
    const trimmedValue = value.trim();
    if (trimmedValue.length === 0) return value;

    // Use custom keywords if provided, otherwise use defaults
    const preservedKeywords = this.defaultKeywords;
    if(customKeywords) preservedKeywords.push(...customKeywords);

    // More sophisticated splitting that handles colons better
    const sentences = trimmedValue.split(/([.!?]+\s*|:\s+)/);
    
    return sentences.map((sentence, index) => {
      if (index % 2 === 1) {
        // This is punctuation - if it's a colon followed by space, we need special handling
        if (sentence.trim() === ':' && sentences[index + 1]) {
          return ': '; // Return colon with space for better formatting
        }
        return sentence;
      }
      
      return this.processSentence(sentence, preservedKeywords);
    }).join('');
  }

  private processSentence(sentence: string, preservedKeywords: string[]): string {
    const words = sentence.split(/\s+/).filter(word => word.length > 0);
    
    if (words.length === 0) return sentence;

    const processedWords = words.map((word, index) => {

      if (index === 0 && word.length > 1 && !this.shouldPreserveWord(word, preservedKeywords)) {
        return this.capitalizeFirstLetter(word.toLowerCase());
      } else if (this.shouldPreserveWord(word, preservedKeywords)) {
        // Preserved keyword: keep as-is (case-sensitive)
        return word;
      } else {
        return word.toLowerCase();
      }
    });

    return processedWords.join(' ');
  }

  private shouldPreserveWord(word: string, preservedKeywords: string[]): boolean {
    const cleanWord = word.replace(/[.,;:!?)]*$/, '');
    
    // Case-sensitive matching: only preserve if the exact case matches
    return preservedKeywords.some(keyword => 
      cleanWord === keyword // Exact case match
    );
  }

  private capitalizeFirstLetter(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
}